import type { MapContentSourceId } from '../domain/layers.ts';

export const localMapContentPaths = Object.freeze({
  cantons: 'data/cantons.geojson',
  'cycling-bike': 'data/cyclingnetwork-bike.geojson',
  'cycling-daily': 'data/cyclingnetwork-daily.geojson',
  'cycling-highway': 'data/cyclingnetwork-highway.geojson',
  'cycling-planned-bike': 'data/cyclingnetwork-planned-bike.geojson',
  'cycling-planned-other': 'data/cyclingnetwork-planned-other.geojson',
  'cycling-route': 'data/cyclingnetwork-route.geojson',
  'riding-areas': 'data/trailforks-ridingarea.geojson',
  zugerbergbahn: 'data/zugerbergbahn.geojson',
} as const satisfies Readonly<Partial<Record<MapContentSourceId, string>>>);

export const localMapContentFiles = Object.freeze(
  Object.values(localMapContentPaths).sort((left, right) => left.localeCompare(right)),
);
